import React, { Fragment, useState, useEffect } from "react";
import { Space, Popconfirm, Input, Button, notification } from 'antd';

import "./Comment.scss";

const buttonStyle = {
  type: "link",
  style: {color: 'black', padding: 0}
};

const Comment = (props) => {
  const [isEditing, setIsEditing] = useState(false);
  const [contentText, setContentText] = useState('');
  const {sessionLoginInfo, commentsData, modComments, delComments} = props;

  useEffect(() => {
    setContentText(commentsData?.commentsContent || '');
  }, [commentsData]);

  const editComments = () => {
    if (contentText.length <= 0) {
      notification.warning({placement: 'bottomLeft', message: `댓글 내용을 입력해주세요.`, duration: 2});
      return false;
    }
    modComments({commentsContent: contentText, commentsId: commentsData.commentsId});
    setIsEditing(false);
  }
  return (
    <Fragment>
      <div className={
        (commentsData?.commentsMakeUserCeType === process.env.REACT_APP_TYPE_YUJIN) 
        ? "comment-bubble-yujin" : "comment-bubble"
      }>
        <div className="comment-content">
        <div className="comment-header">
            <Space>
              <span className="comment-author">{commentsData?.commentsMakeUserNm || ''}</span>
              <span className="comment-date">{commentsData?.commentsMakeDate || ''}</span>
            </Space>
            {/* 작성자만 수정가능 */}
            {(sessionLoginInfo?.ceCd === commentsData?.commentsMakeUser) && (
              isEditing ? (
              <Space>
                <Button {...buttonStyle}
                  onClick={()=>editComments()}
                >저장</Button>
                <Button {...buttonStyle}
                  onClick={()=>{
                    setIsEditing(false);
                    setContentText(commentsData?.commentsContent || '');
                  }}
                >취소</Button>
              </Space>
            ) : (
              <Space>
                <Button {...buttonStyle}
                  onClick={()=>setIsEditing(true)}
                >수정</Button>
                <Popconfirm 
                  title="삭제하시겠습니까?"
                  onConfirm={() => delComments(commentsData?.commentsId)}
                  onClick={(e)=>e.stopPropagation()}
                ><Button {...buttonStyle}>삭제</Button></Popconfirm>
              </Space>
            ))}
          </div>
          {isEditing ? (
            <div className="comment-edit">
              <Input.TextArea 
                className='height-100 comment_edit_write'
                autoSize={true}
                value={contentText}
                onChange={(e)=>setContentText(e.target.value)}                 
              />
            </div>
          ) : (
            <Fragment>
              {commentsData?.commentsContent.split(`\n`).map((item, idx)=>{
                return (
                  <Fragment key={idx}>
                    {item}
                    {commentsData.commentsContent.split(`\n`).length > idx+1 && <br />}
                  </Fragment>
              )})}
            </Fragment>
          )} 
        </div>
      </div>
    </Fragment>
  );
}

export default Comment;